<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>{{ $t('accountWithdrawalApplyFkManage.title') }}</span>
          </div>
          <el-table :data="accountWithdrawalApplyFkManageInfo.accountWithdrawalApplyFks" style="width: 100%" border>
            <el-table-column prop="amount" :label="$t('accountWithdrawalApplyFkManage.amount')" align="center" />
            <el-table-column prop="applyUserName" :label="$t('accountWithdrawalApplyFkManage.applyUserName')"
              align="center" />
            <el-table-column prop="applyUserTel" :label="$t('accountWithdrawalApplyFkManage.applyUserTel')"
              align="center" />
            <el-table-column prop="context" :label="$t('accountWithdrawalApplyFkManage.context')" align="center" />
            <el-table-column prop="stateName" :label="$t('accountWithdrawalApplyFkManage.stateName')" align="center" />
            <el-table-column :label="$t('accountWithdrawalApplyFkManage.operation')" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="_openAccountPaykModal(scope.row)">
                  {{ $t('accountWithdrawalApplyFkManage.pay') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next, jumper" :total="accountWithdrawalApplyFkManageInfo.total"
            style="margin-top: 20px; text-align: right;" />
        </el-card>
      </el-col>
    </el-row>

    <account-pay ref="accountPay" @submit="_auditAccountWithdrawalApplyFkState" />
  </div>
</template>

<script>
import { listStateWithdrawalApplys, upAccountWithdrawalApply } from '@/api/admin/accountWithdrawalApplyFkManage/accountWithdrawalApplyFkManageApi'
import AccountPay from '@/components/admin/accountPay/AccountPay'

export default {
  name: 'AccountWithdrawalApplyFkManage',
  components: {
    AccountPay
  },
  data() {
    return {
      accountWithdrawalApplyFkManageInfo: {
        accountWithdrawalApplyFks: [],
        accountBanks: [],
        total: 0,
        records: 1,
        moreCondition: false,
        applyId: '',
        acctId: '',
        conditions: {
          state: '586',
          page: 1,
          row: 10
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listAccountWithdrawalApplyFks(this.currentPage, this.pageSize)
  },
  methods: {
    async _listAccountWithdrawalApplyFks(page, rows) {
      this.accountWithdrawalApplyFkManageInfo.conditions.page = page
      this.accountWithdrawalApplyFkManageInfo.conditions.row = rows

      try {
        const res = await listStateWithdrawalApplys(this.accountWithdrawalApplyFkManageInfo.conditions)
        this.accountWithdrawalApplyFkManageInfo = {
          ...this.accountWithdrawalApplyFkManageInfo,
          ...res,
          accountWithdrawalApplyFks: res.data
        }
        this.currentPage = page
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleCurrentChange(val) {
      this._listAccountWithdrawalApplyFks(val, this.pageSize)
    },
    _openAccountPaykModal(row) {
      this.accountWithdrawalApplyFkManageInfo.applyId = row.applyId
      this.accountWithdrawalApplyFkManageInfo.acctId = row.acctId
      this.$refs.accountPay.open(row.bankId)
    },
    async _auditAccountWithdrawalApplyFkState(data) {
      const params = {
        ...data,
        applyId: this.accountWithdrawalApplyFkManageInfo.applyId,
        acctId: this.accountWithdrawalApplyFkManageInfo.acctId,
        context: data.remark
      }

      if (params.state === '1100') {
        params.state = '686'
      } else if (params.state === '1200') {
        params.state = '687'
      }

      try {
        await upAccountWithdrawalApply(params)
        this._listAccountWithdrawalApplyFks(this.currentPage, this.pageSize)
        this.$message.success(this.$t('common.operateSuccess'))
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error(this.$t('common.operateFail'))
      }
    }
  }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-col {
  width: 100%;
}
</style>